/* themes/dawn-hp-concept/assets/pulse-finder.js
   The dance sneaker finder (spec: docs/superpowers/specs/2026-09-11-dance-sneaker-finder-design.md).
   Pure functions first, so scripts/finder/tests/scoring.test.mjs can run them in Node. The DOM
   controller (init) is added in Task 4 and only runs when a [data-finder] root exists. */
(function (root) {
  'use strict';
  var MODELS = ['flow2', 'nova', 'volt'];

  function idx(model) { return MODELS.indexOf(model); }

  /* picks: one entry per answered screen, in screen order. Decider picks carry {model}. */
  function score(picks) {
    var s = [0, 0, 0], wide = false;
    picks.forEach(function (p) {
      if (!p || p.kind === 'decider') return;
      if (p.lean) for (var m = 0; m < 3; m++) s[m] += Number(p.lean[m]) || 0;
      if (p.wide) wide = true;
    });
    var order = [0, 1, 2].sort(function (x, y) {
      if (s[y] !== s[x]) return s[y] - s[x];
      for (var i = 0; i < picks.length; i++) {          /* tie: the EARLIER question with a difference decides */
        var p = picks[i];
        if (!p || p.kind === 'decider' || !p.lean) continue;
        if (p.lean[x] !== p.lean[y]) return p.lean[y] - p.lean[x];
      }
      return x - y;
    }).map(function (i) { return MODELS[i]; });
    return { scores: s, order: order, wide: wide };
  }

  function deciderOrder(picks) { return score(picks).order; }

  function resolve(picks) {
    var r = score(picks), order = r.order.slice(), decider = null, match, runner, third, note = '';
    picks.forEach(function (p) { if (p && p.kind === 'decider' && p.model) decider = p.model; });
    if (!r.wide && decider) order = [decider].concat(order.filter(function (m) { return m !== decider; }));
    if (r.wide) { match = 'wide'; runner = order[0]; third = order[1]; }
    else { match = order[0]; runner = order[1]; third = order[2]; }
    var wi = r.wide ? 0 : idx(match);                  /* Flow 2 Wide shares Flow 2's leans */
    var ri = idx(runner);
    var reasons = [], leads = [];
    picks.forEach(function (p) {
      if (!p) return;
      if (p.kind === 'decider') { if (!r.wide && p.reason && p.model === match) reasons.unshift(p.reason); return; }
      if (p.reason && (p.wide || p.lean[wi] > 0)) reasons.push(p.reason);
      if (p.leads && p.lean[wi] === 0 && p.lean[ri] > 0) leads.push(p.leads);
    });
    if (r.wide) note = 'Standard width, if you are between the two: ' + runner + '.';
    return { match: match, runner: runner, third: third, wide: r.wide, reasons: reasons, leads: leads, note: note };
  }

  function encode(indices) { return 'a=' + indices.join('.'); }
  function decode(hash) {                              /* anchored: only a bare #a=... is a replay */
    var m = String(hash || '').replace(/^[#?]/, '').match(/^a=([\d.]+)$/);
    return m ? m[1].split('.').map(Number) : null;
  }

  /* "a" | "a and b" | "a, b and c". Never "a and b and c". */
  function joinList(items, and) {
    var a = (items || []).filter(function (t) { return t; });
    if (a.length < 2) return a[0] || '';
    return a.slice(0, -1).join(', ') + ' ' + (and || 'and') + ' ' + a[a.length - 1];
  }

  var api = { MODELS: MODELS, score: score, deciderOrder: deciderOrder, resolve: resolve, encode: encode, decode: decode,
              joinList: joinList, init: function () { return false; } };

  function init(rootEl) {
    if (!rootEl) return false;
    var $ = function (s, el) { return (el || rootEl).querySelector(s); };
    var $$ = function (s, el) { return Array.prototype.slice.call((el || rootEl).querySelectorAll(s)); };
    var screens = $$('[data-screen="q"]'), intro = $('[data-screen="intro"]'), result = $('[data-screen="result"]');
    /* the storefront's language (2026-09-15): the section prints [data-finder-i18n] from locales/*.json, pulse_finder */
    var T = { question_of: 'Question [n] of [total]', getting_started: 'Just getting started', answered: '[n] of [total] answered',
      to_go: '[n] to go', leads_on: 'Leads on [list].', also_asked: 'You also asked for [list], which is where [name] leads.', and: 'and',
      wide_between: 'Standard width, if you are between the two: [name].' };
    try { var tj = JSON.parse(($('[data-finder-i18n]') || {}).textContent || '{}'); for (var tk in tj) if (tj[tk]) T[tk] = tj[tk]; } catch (e) {}
    function tf(tpl, map) { return String(tpl).replace(/\[(\w+)\]/g, function (w, k) { return Object.prototype.hasOwnProperty.call(map, k) ? String(map[k]) : w; }); }
    var names = {}; $$('[data-model-block]').forEach(function (b) { names[b.getAttribute('data-model-block')] = b.getAttribute('data-name'); });
    var picks = [], indices = [];
    var live = false; /* true only when the result came from the shopper's own clicks, never a #a= replay or a shared link */
    function publish(name, payload) { try { if (root.Shopify && root.Shopify.analytics && root.Shopify.analytics.publish) root.Shopify.analytics.publish(name, payload); } catch (e) {} }
    function pickFromCard(card) {
      return { kind: card.closest('[data-screen="q"]').getAttribute('data-kind'),
               lean: card.getAttribute('data-lean').split(',').map(Number), wide: card.getAttribute('data-wide') === 'true',
               reason: card.getAttribute('data-reason') || '', leads: card.getAttribute('data-leads') || '',
               model: card.getAttribute('data-model') || '' };
    }
    function isWide() { return picks.some(function (p) { return p && p.wide; }); }
    /* Every screen counts. The decider is still SKIPPED on Wide, but the bar must not renumber
       itself mid-run: subtracting the skipped screen turned "of 7" into "of 6" after an answer. */
    function total() { return screens.length; }
    function show(el) {
      intro.hidden = true; result.hidden = true; screens.forEach(function (s) { s.hidden = true; });
      el.hidden = false; root.scrollTo({ top: 0 });
      var h = el.querySelector('[data-q-heading], [data-result-title]'); if (h) h.focus({ preventScroll: true });
    }
    function renderQ(i) {
      var s = screens[i], t = total();
      if (s.getAttribute('data-kind') === 'decider') {
        if (isWide()) { renderResult(); return; }
        var order = deciderOrder(picks.slice(0, i)), cards = $$('[data-pick]', s), byModel = {};
        cards.forEach(function (c) { byModel[c.getAttribute('data-model')] = c; });
        order.forEach(function (m, rank) {
          var c = byModel[m]; if (!c) return;
          c.parentNode.appendChild(c);
          c.classList.toggle('card--best', rank < 2); $('[data-badge]', c).hidden = rank >= 2;
          var wi = idx(m), leads = picks.slice(0, i).filter(function (p) { return p.leads && p.lean[wi] > 0; }).map(function (p) { return p.leads; });
          $('[data-leads-text]', c).textContent = leads.length ? tf(T.leads_on, { list: leads.join(', ') }) : '';
        });
      }
      $('[data-step]', s).textContent = tf(T.question_of, { n: i + 1, total: t });
      var segs = ''; for (var k = 0; k < t; k++) segs += '<i class="' + (k < i ? 'is-done' : k === i ? 'is-now' : '') + '"></i>';
      $('[data-prog-segs]', s).innerHTML = segs;
      $('[data-prog]', s).setAttribute('aria-valuenow', i); $('[data-prog]', s).setAttribute('aria-valuemax', t);
      $('[data-prog-done]', s).textContent = i === 0 ? T.getting_started : tf(T.answered, { n: i, total: t });
      $('[data-prog-left]', s).textContent = tf(T.to_go, { n: t - i });
      $$('[data-pick]', s).forEach(function (card) {
        card.onclick = function () {
          live = true;
          picks[i] = pickFromCard(card); indices[i] = $$('[data-pick]', s).indexOf(card);
          picks.length = i + 1; indices.length = i + 1;
          publish('pulse_finder_step', { question: s.getAttribute('data-key'), answer: card.querySelector('.card__k').textContent.trim() });
          if (i + 1 < screens.length) renderQ(i + 1); else renderResult();
        };
      });
      $('[data-back]', s).onclick = function () { if (i === 0) show(intro); else renderQ(i - 1); };
      show(s);
    }
    function place(model, slot, role) {
      var b = $('[data-model-block="' + model + '"]'); if (!b) return null;
      $('[data-slot="' + slot + '"]').appendChild(b); b.setAttribute('data-role', role); b.hidden = false; return b;
    }
    var last = null;
    function renderResult() {
      var r = resolve(picks); last = r;
      $$('[data-model-block]').forEach(function (b) { $('[data-model-bank]').appendChild(b); b.hidden = true; b.removeAttribute('data-role'); });
      var m = place(r.match, 'match', 'match'), u = place(r.runner, 'runner', 'runner'); place(r.third, 'third', 'third');
      if (!m || !u) {                                  /* no block for this model: $() would fall back to the root and write into the wrong card */
        console.warn('[pulse] finder: no model block for ' + r.match + ' / ' + r.runner); return;
      }
      $('[data-result-title]').textContent = names[r.match] || '';
      $('[data-reasons]', m).innerHTML = r.reasons.map(function (t) { return '<li>' + t.replace(/</g, '&lt;') + '</li>'; }).join('');
      var note = $('[data-note]', m); note.textContent = r.note ? tf(T.wide_between, { name: names[r.runner] || r.runner }) : ''; note.hidden = !r.note;
      $('[data-runner-line]', u).textContent = r.leads.length
        ? tf(T.also_asked, { list: joinList(r.leads, T.and), name: names[r.runner] || r.runner })
        : u.getAttribute('data-runner-default');
      root.location.hash = encode(indices);
      publish('pulse_finder_result', { match: r.match, runner_up: r.runner, wide: r.wide });
      if (live && root.PulseSizeTrack) {
        var t = root.PulseSizeTrack, ctx = t.context(), ans = {};
        screens.forEach(function (s, k) {
          if (!picks[k]) return;
          var card = $$('[data-pick]', s)[indices[k]];
          if (card) ans[s.getAttribute('data-key')] = card.querySelector('.card__k').textContent.trim();
        });
        var mName = names[r.match] || r.match, rName = names[r.runner] || r.runner;
        t.recordStyle({
          surface: 'style finder', market: ctx.market, match: mName, runner_up: rName, wide: !!r.wide, answers: ans,
          summary: mName + (r.wide ? ' (wide)' : '') + ', runner-up ' + rName + ' | ' +
            Object.keys(ans).map(function (q) { return q + ': ' + ans[q]; }).join('; ') + ' (style finder)'
        });
        live = false;
      }
      show(result);
    }
    $('[data-start]').onclick = function () { picks = []; indices = []; if (root.PulseSizeTrack) root.PulseSizeTrack.ga('style_finder_start', { market: root.PulseSizeTrack.context().market }); renderQ(0); };
    $('[data-again]').onclick = function () { picks = []; indices = []; root.history.replaceState(null, '', root.location.pathname); show(intro); };

    /* ---- the form: Klaviyo subscription + Finder result event.
       It IS a real Shopify {% form 'contact' %}. An email-only submission is handled in-page and
       never posts. A submission carrying a typed question is allowed to submit NATIVELY, so
       Shopify's own captcha script mints the token it demands (a hand-rolled fetch, and a hidden
       form driven through Shopify.captcha.protect, both die on "400 Missing CAPTCHA token").
       The reload loses the #a= hash, so the picks are stashed in sessionStorage and replayed on
       the way back in.

       THE LISTENER IS ON window, IN THE CAPTURE PHASE, AND THAT IS LOAD-BEARING. Shopify's captcha
       binds its own submit listener to the form: it cancels the event, solves hCaptcha, then calls
       form.submit() itself, which fires no event and cannot be cancelled. So preventDefault() from a
       listener on the form does NOT keep an email-only submission in the page -- measured on the live
       page, it navigated anyway. A capture listener on window runs before any listener on the form,
       so stopImmediatePropagation() there is the only thing that can hold the page. ---- */
    var form = $('[data-finder-form]') || $('form.ask__form');
    if (form) root.addEventListener('submit', function (ev) {
      if (ev.target !== form) return;
      var emailEl = form.querySelector('[name="contact[email]"]'), qEl = form.querySelector('[name="contact[Message]"]');
      var email = emailEl ? emailEl.value.trim() : '', question = qEl ? qEl.value.trim() : '';
      if (!email || !/.+@.+\..+/.test(email) || !last) { ev.preventDefault(); ev.stopImmediatePropagation(); if (emailEl) emailEl.focus(); return; }
      /* An email-only submission is handled in the page and must NEVER reach a native submit, so it
         is cancelled HERE, before any of the work below can throw. A submission carrying a question
         is deliberately left alone: Shopify's captcha listener has to see the event. */
      if (!question) { ev.preventDefault(); ev.stopImmediatePropagation(); }
      var props = { pulse_market: rootEl.getAttribute('data-market'), pulse_domain: rootEl.getAttribute('data-domain'), pulse_source: 'finder' };
      try { var sc = root.PulseSizeScale && root.PulseSizeScale.get && root.PulseSizeScale.get(); if (sc === 'm') props.pulse_gender = 'men'; else if (sc === 'w') props.pulse_gender = 'women'; } catch (e) {}
      var matchBlock = $('[data-model-block="' + last.match + '"]');
      var ev_props = { match: last.match, match_name: names[last.match], runner_up: last.runner, runner_up_name: names[last.runner], third: last.third, wide: last.wide,
                       reasons: last.reasons, headline: (matchBlock.querySelector('.rm__line') || {}).textContent || '',
                       image: (matchBlock.querySelector('.rm__img img') || {}).src || '',
                       collection_url: root.location.origin + matchBlock.getAttribute('data-collection-url'),
                       result_url: root.location.href, question: question };
      var answerPairs = [];
      screens.forEach(function (s, i) {
        if (!picks[i]) return;
        var label = $$('[data-pick]', s)[indices[i]].querySelector('.card__k').textContent.trim();
        ev_props['answer_' + s.getAttribute('data-key')] = label;
        answerPairs.push(s.getAttribute('data-key') + ': ' + label);
      });
      var company = rootEl.getAttribute('data-klaviyo-id'), list = rootEl.getAttribute('data-list');
      var H = { 'Content-Type': 'application/json', 'revision': '2025-07-15' };
      var sub = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), { method: 'POST', keepalive: true, headers: H,
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Dance sneaker finder',
          profile: { data: { type: 'profile', attributes: { email: email, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
          relationships: { list: { data: { type: 'list', id: list } } } } }) });
      var evt = fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), { method: 'POST', keepalive: true, headers: H,
        body: JSON.stringify({ data: { type: 'event', attributes: { properties: Object.assign({}, props, ev_props),
          metric: { data: { type: 'metric', attributes: { name: 'Finder result' } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } } } }) });

      if (question) {
        var ctx = function (k, v) { var el = form.querySelector('[data-ctx="' + k + '"]'); if (el) el.value = v; };
        ctx('subject', 'Finder question: ' + names[last.match]);
        ctx('match', names[last.match] + (last.wide ? ' (wide)' : ''));
        ctx('runner', names[last.runner] || '');
        ctx('answers', answerPairs.join('; '));
        ctx('result', root.location.href);
        try { root.sessionStorage.setItem('pulse-finder-sent', JSON.stringify({ a: indices, sent: true })); } catch (e) {}
        publish('pulse_finder_form', { question: true });
        sub.catch(function () { return { ok: false }; }).then(function (r) { if (!r.ok) console.warn('[pulse] finder subscription rejected'); });
        evt.catch(function () { return { ok: false }; }).then(function (r) { if (!r.ok) console.warn('[pulse] finder event rejected'); });
        return; /* neither cancelled nor stopped: the event reaches Shopify's captcha listener, which
                   solves hCaptcha and submits the form with a token */
      }

      Promise.all([sub.catch(function () { return { ok: false }; }), evt.catch(function () { return { ok: false }; })]).then(function (rs) {
        var ok = rs[1].ok;
        $('[data-form-ok]').hidden = !ok; $('[data-form-fail]').hidden = ok;
        if (!ok) { var a = $('[data-mailto]'); a.href = 'mailto:' + rootEl.getAttribute('data-support-email') + '?subject=' + encodeURIComponent('Finder question: ' + names[last.match]) + '&body=' + encodeURIComponent(question + '\n\n' + root.location.href); }
        if (!rs[0].ok) console.warn('[pulse] finder subscription rejected');
        publish('pulse_finder_form', { question: false, ok: ok });
      });
    }, true);

    /* ---- URL-addressable result: #a=0.1.2.0.1.0.2 replays those card indices ---- */
    function replayIndices(arr) {
      live = false;
      if (!arr || arr.length < screens.length - 1) return false;
      picks = []; indices = [];
      var ok = true;
      arr.forEach(function (n, i) {
        if (!ok || !screens[i]) return;
        if (screens[i].getAttribute('data-kind') === 'decider') { renderQ(i); }
        var card = $$('[data-pick]', screens[i])[n]; if (!card) { ok = false; return; }
        picks[i] = pickFromCard(card); indices[i] = n;
      });
      if (!ok) { picks = []; indices = []; return false; }
      if (picks.length === screens.length || isWide()) renderResult(); else renderQ(picks.length);
      return true;
    }
    replayIndices(decode(root.location.hash));

    /* ---- back from a native contact-form submit: Shopify reloaded the page on ?contact_posted=true,
       which drops the #a= hash. Replay the stashed picks, show the success line, and rewrite the URL
       so a refresh cannot resubmit. ---- */
    var posted = rootEl.querySelector('[data-contact-posted]'), errored = rootEl.querySelector('[data-contact-errors]');
    if (posted || errored) {
      var saved = null, replayed = false;
      try { saved = JSON.parse(root.sessionStorage.getItem('pulse-finder-sent') || 'null'); } catch (e) {}
      try { root.sessionStorage.removeItem('pulse-finder-sent'); } catch (e) {}
      if (saved && saved.a) replayed = replayIndices(saved.a);
      if (replayed && posted) {
        $('[data-form-ok]').hidden = false; $('[data-form-fail]').hidden = true;
        try { root.history.replaceState(null, '', root.location.pathname + root.location.hash); } catch (e) {}
      }
      if (!replayed) {
        /* Storage was blocked, or Shopify re-rendered with form.errors and nothing to replay. Both
           the error and the sent line live INSIDE the result screen, so landing on the intro would
           show the customer nothing at all. Unhide the result with no match placed and put the form
           on screen; the scored cards simply are not there to restore. */
        intro.hidden = true; screens.forEach(function (s) { s.hidden = true; }); result.hidden = false;
        var eyebrow = result.querySelector('.res__head .eyebrow');
        $('[data-result-title]').textContent = eyebrow ? eyebrow.textContent.trim() : '';
        if (form) form.scrollIntoView();
      }
    }
    return true;
  }
  api.init = init;
  root.PulseFinder = api;
  if (typeof document !== 'undefined') {
    var boot = function () { init(document.querySelector('[data-finder]')); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  }
})(typeof window !== 'undefined' ? window : globalThis);
